import React from "react";
import { motion } from "framer-motion";

export function Reveal({ children, delay = 0, y = 18, className, ...rest }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-8% 0px" }}
      transition={{ duration: 0.6, delay, ease: [0.22, 0.61, 0.36, 1] }}
      {...rest}
    >
      {children}
    </motion.div>
  );
}

export function KatlasMark({ size = 26 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 64 64" aria-hidden="true">
      <rect width="64" height="64" rx="14" fill="#13233B" />
      <circle cx="32" cy="32" r="12" fill="none" stroke="#F3EFE6" strokeWidth="3.2" />
      <circle cx="32" cy="32" r="4.4" fill="#2660F2" />
    </svg>
  );
}
